import { toast } from 'react-toastify';
import { DURATION, NOTIFICATION } from 'common/constants';
import queryString from 'query-string';

export default ({
  type,
  title,
  autoClose = DURATION.LONG,
  closeButton = true,
  closeOnClick = true,
  hideProgressBar = true,
  position = toast.POSITION.BOTTOM_LEFT,
}) => {
  const isChatOnly = queryString.parse(window.location.search)['chat_only'] !== 'true';
  return isChatOnly
    ? toast(title, {
        type,
        autoClose,
        closeButton,
        closeOnClick,
        containerId: NOTIFICATION.VARIANTS.DEFAULT,
        hideProgressBar,
        position,
        ...(position === toast.POSITION.BOTTOM_LEFT && { className: 'custom-toast-position' }),
      })
    : '';
};
